import { render, staticRenderFns } from "./AccordionComponent.vue?vue&type=template&id=d6e77e2e&scoped=true"
import script from "./AccordionComponent.vue?vue&type=script&lang=js"
export * from "./AccordionComponent.vue?vue&type=script&lang=js"
import style0 from "./AccordionComponent.vue?vue&type=style&index=0&id=d6e77e2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e77e2e",
  null
  
)

export default component.exports